import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { 
  FaStore, 
  FaToggleOn, 
  FaToggleOff, 
  FaSpinner, 
  FaBell,
  FaArrowRight,
  FaTimes,
  FaCheckDouble,
  FaMapMarkerAlt,
  FaUtensils,
  FaCheckCircle,
  FaInfoCircle
} from "react-icons/fa";
import Sidebar from "../components/layout/Dashboard/Sidebar";
import DashboardHome from "../components/layout/Dashboard/Home";
import Campaigns from "../components/layout/Dashboard/Campaigns";
import OrdersList from "../components/layout/Dashboard/OrdersList ";
import EarningsDashboard from "../components/layout/Dashboard/EarningsDashboard";
import MenuMaster from "../components/layout/Dashboard/MenuMaster";
import StoreProfile from "../components/layout/Dashboard/Profile";
import MOUAgreement from "../components/layout/Dashboard/MOUAgreement";
import INITIAL_NOTIFICATIONS from "../components/layout/Dashboard/INITIAL_NOTIFICATIONS";
import AddOffer from "../components/layout/Dashboard/AddofferScreen";
import HelpSupport from "../components/layout/Dashboard/support/HelpSupportScreen";
import SupportTicket from "../components/layout/Dashboard/support/Ticket";
import VerificationScreen from "../components/layout/Dashboard/VerificationScreen";
import MenuUpdate from "../components/layout/Dashboard/MenuUpdate";
import EditAddressScreen from "../components/layout/Dashboard/EditAddress";
import RestaurantProfile from "../components/layout/Dashboard/Restaurantinfo";
import { putData, postData, getData } from "../Services/Fetchnodeservices";
import LiveOrdersTerminal from "../components/layout/Dashboard/LiveOrdersTerminal";
import socket from "../Services/socket";
import { useRef } from "react";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // 🔥 Open/Close State
  const [isRestaurantOpen, setIsRestaurantOpen] = useState(true);
  const [isToggling, setIsToggling] = useState(false);
  
  // 🔥 Orders State
  const [orders, setOrders] = useState([]);
  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
const ORDER_TIMEOUT = 60; // seconds
  // 🔥 ORDER POPUP STATE
  const [orderPopup, setOrderPopup] = useState({ visible: false, orderData: null });
  const [orderAccepted, setOrderAccepted] = useState(false);
  const [lastOrderId, setLastOrderId] = useState(null);
  const [countdown, setCountdown] = useState(ORDER_TIMEOUT);
  // const [timerStarted, setTimerStarted] = useState(false);
  const popupOpenRef = useRef(false);
  

  useEffect(() => {
  if (userData) {
    loadRestaurantStatus();
  }
}, [userData]);
  const location = useLocation();
const alarmRef = useRef(null);
const loadRestaurantStatus = async () => {
  const restaurantId =
    userData?.id ||
    userData?.restaurantId ||
    localStorage.getItem("restaurantId");

  if (!restaurantId) return;

  try {
    const response = await getData(
      `orderRoutes/restaurant/details/${restaurantId}`
    );

    if (response.success) {
      setIsRestaurantOpen(
        Number(response.data.open_status) === 1
      );
    }
  } catch (err) {
    console.log(err);
  }
};

useEffect(() => {
  if (!userData) return;

  loadRestaurantStatus();

  const interval = setInterval(() => {
    loadRestaurantStatus();
  }, 5000);

  return () => clearInterval(interval);
}, [userData]);

useEffect(() => {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission();
  }
}, []);
useEffect(() => {
  alarmRef.current = new Audio("/sounds/new-order.mp3");
  alarmRef.current.loop = true;
  alarmRef.current.volume = 1;
}, []);

const playAlarm = () => {
  if (!alarmRef.current) return;

  alarmRef.current.currentTime = 0;

  alarmRef.current.play().catch((err) => {
    console.log("Alarm:", err);
  });
};

const stopAlarm = () => {
  if (!alarmRef.current) return;

  try {
    alarmRef.current.pause();
    alarmRef.current.currentTime = 0;
    alarmRef.current.loop = false;
    alarmRef.current.src = "";
    alarmRef.current.load();
  } catch (err) {
    console.log("Stop alarm error:", err);
  }

  alarmRef.current = new Audio("/sounds/new-order.mp3");
  alarmRef.current.loop = true;
  alarmRef.current.volume = 1;
};
  // 🔥 Load restaurant status from localStorage

  // 🔥 Toggle restaurant open/closed status
  const toggleRestaurantStatus = async () => {
    const restaurantId = userData?.id || userData?.restaurantId || localStorage.getItem('restaurantId');
    if (!restaurantId) {
      alert('Restaurant ID not found. Please login again.');
      return;
    }

    setIsToggling(true);
    try {
      const newStatus = !isRestaurantOpen;
      const response = await putData(`orderRoutes/restaurant/toggle-status/${restaurantId}`, { open: newStatus });

      if (response.success) {
        setIsRestaurantOpen(newStatus);
        if (userData) {
          const updatedUserData = { ...userData, isOpen: newStatus, open_status: newStatus ? "1" : "0" };
          localStorage.setItem('userData', JSON.stringify(updatedUserData));
          setUserData(updatedUserData);
        }
      } else {
        alert(response.message || 'Failed to update status');
      }
    } catch (error) {
      console.error('❌ Error toggling status:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setIsToggling(false);
    }
  };
useEffect(() => {
  if (!userData) return;

  const restaurantId =
    userData?.id ||
    userData?.restaurantId ||
    localStorage.getItem("restaurantId");

  if (!restaurantId) {
    console.log("❌ Restaurant ID not found");
    return;
  }

  const handleConnect = () => {
    console.log("🟢 Socket Connected:", socket.id);

    socket.emit("join-restaurant-panel", {
      restaurantId,
    });

    console.log("📤 Join Event Sent:", restaurantId);
  };

  const handleDisconnect = () => {
    console.log("🔴 Socket Disconnected");
  };

  const handleConnectError = (err) => {
    console.error("❌ Socket Connection Error:", err.message);
  };

//   const handleRestaurantNotification = async (data) => {

//   console.log("🍽️ SOCKET RECEIVED:", data);

//   playAlarm();

//   if ("Notification" in window) {

//     if (Notification.permission === "granted") {

//       new Notification("🍽️ New Order", {
//         body: data.message,
//         icon: "/favicon.ico",
//       });

//     } else if (Notification.permission !== "denied") {

//       await Notification.requestPermission();

//     }

//   }

//   loadOrders();
// };

const handleRestaurantNotification = async (data) => {

  console.log("🍽️ SOCKET RECEIVED:", data);
  if (data.type === "schedule") {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(data.title, {
        body: data.message,
        icon: "/favicon.ico",
        badge: "/favicon.ico",
        requireInteraction: true,
        silent: false,
      });
    });
  }

  return;
}

  // ==========================
  // New Order Notification
  // ==========================

  // ==========================
// New Order Notification
// ==========================

playAlarm();

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.showNotification("🍽️ New Order", {
      body: data.message,
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      requireInteraction: true,
      silent: false,
    });
  });
}

loadOrders();
};


  // Register listeners
  socket.on("connect", handleConnect);
  socket.on("disconnect", handleDisconnect);
  socket.on("connect_error", handleConnectError);
  socket.on("restaurant-notification", handleRestaurantNotification);

  // Connect if not connected
  if (!socket.connected) {
    socket.connect();
  } else {
    handleConnect();
  }

  return () => {
    socket.off("connect", handleConnect);
    socket.off("disconnect", handleDisconnect);
    socket.off("connect_error", handleConnectError);
    // socket.off("restaurant-notification");
    socket.off("restaurant-notification", handleRestaurantNotification);
  };
}, [userData]);
  // 🔥 Load Orders from API
  const loadOrders = async () => {
    const restaurantId = userData?.id || userData?.restaurantId || localStorage.getItem('restaurantId');
    if (!restaurantId) return;

    try {
      setIsLoadingOrders(true);
      const response = await getData(`orderRoutes/orders/pending/BUSINESS/${restaurantId}`);

      if (response.success) {
        const ordersData = response.data || [];
        setOrders(ordersData);
        
        const pending = ordersData.filter(order => order.order_status_restro === 'pending' || order.status === 'pending');
        setPendingOrders(pending);
        setNewOrdersCount(pending.length);

        if (
    pending.length > 0 &&
    !popupOpenRef.current &&
    !orderAccepted
) {
    const latestOrder = pending[0];
    const orderId = latestOrder.id || latestOrder.order_id;

    if (orderId !== lastOrderId) {
        setLastOrderId(orderId);
        showOrderPopup(latestOrder);
    }
}
      } else {
        setOrders([]);
        setPendingOrders([]);
        setNewOrdersCount(0);
      }
    } catch (error) {
      console.error('❌ Error fetching orders:', error);
      setOrders([]);
      setPendingOrders([]);
      setNewOrdersCount(0);
    } finally {
      setIsLoadingOrders(false);
    }
  };

  const getSafeItems = (items) => {
    if (!items) return ['1x Item'];
    if (Array.isArray(items)) return items.length > 0 ? items : ['1x Item'];
    if (typeof items === 'string') {
      try {
        const parsed = JSON.parse(items);
        if (Array.isArray(parsed)) return parsed.length > 0 ? parsed : ['1x Item'];
      } catch (e) {
        const splitItems = items.split(',').map(item => item.trim()).filter(item => item);
        if (splitItems.length > 0) return splitItems;
      }
    }
    return ['1x Item'];
  };

  const showOrderPopup = (order) => {
    if (popupOpenRef.current) return;


    const items = getSafeItems(order.items || order.order_items || order.products);
    const popupData = {
      id: order.id || order.order_id || '#ORD-' + Date.now(),
      customer: order.receiver_name || order.customer_name || order.user_name || 'Customer',
      address: order.dropoff_address || order.delivery_address || order.address || 'Address not available',
      items: items,
      total: order.total_amount || order.amount || order.total || 0,
      restaurantEarning: order.business_amount || order.restaurant_earning || 0,
      estimatedTime: order.estimated_time || order.delivery_time || '20-30 min',
    };
    // setOrderPopup({ visible: true, orderData: popupData });
//    if (!timerStarted) {
//     setCountdown(30);
//     setTimerStarted(true);
// }

popupOpenRef.current = true;

  // setCountdown(30);
setCountdown(ORDER_TIMEOUT);
  setOrderPopup({
    visible: true,
    orderData: popupData,
  });

  };

  const handleAcceptOrder = async () => {
    const orderId = orderPopup.orderData?.id;
    if (!orderId) return;

    setOrderAccepted(true);
    setOrderPopup({ visible: false, orderData: null });
    stopAlarm();
    popupOpenRef.current = false;
    // setTimerStarted(false);
    setCountdown(30);
    setCountdown(ORDER_TIMEOUT);
    try {
      const response = await putData(`orderRoutes/order/accept/${orderId}`);
      if (response.success) {
        navigate('/dashboard/LiveOrdersTerminal');
        setTimeout(() => loadOrders(), 2000);
      } else {
        alert(response.message || 'Failed to accept order.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

//   const handleDeclineOrder = async () => {
//     const orderId = orderPopup.orderData?.id;
//     if (!orderId) return;
// stopAlarm();
//     setOrderPopup({ visible: false, orderData: null });
//     try {
//       const response = await putData(`orderRoutes/order/decline/${orderId}`);
//       if (response.success) {
//         setTimeout(() => loadOrders(), 1000);
//       }
//     } catch (error) {
//       console.error('Error declining order:', error);
//     }
//   };

const handleDeclineOrder = async () => {
  const orderId = orderPopup.orderData?.id;
  if (!orderId) return;

  stopAlarm();
  popupOpenRef.current = false;
  // setTimerStarted(false);
  // setCountdown(30);
  setCountdown(ORDER_TIMEOUT);

  setLastOrderId(orderId);
  setOrderAccepted(true);

  setOrderPopup({
    visible: false,
    orderData: null,
  });

  try {
    const response = await putData(`orderRoutes/order/decline/${orderId}`);

    if (response.success) {
      setTimeout(() => {
        loadOrders();
        setOrderAccepted(false);
      }, 1000);
    }
  } catch (error) {
    console.error(error);
    setOrderAccepted(false);
  }
};
useEffect(() => {
    if (!orderPopup.visible) return;

    if (countdown <= 0) {
        stopAlarm();
        popupOpenRef.current = false;
        handleDeclineOrder();
        return;
    }

    const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);

}, [orderPopup.visible, countdown]);
  // 🔥 Navigate to LiveOrdersTerminal
  const handleNewOrderClick = () => {
    navigate('/dashboard/LiveOrdersTerminal');
  };

  useEffect(() => {
  const unlockAudio = async () => {
  if (!alarmRef.current) return;

  try {
    alarmRef.current.muted = true;
    await alarmRef.current.play();
    alarmRef.current.pause();
    alarmRef.current.currentTime = 0;
    alarmRef.current.muted = false;

    console.log("✅ Audio unlocked");
  } catch (e) {
    console.log("❌ Unlock failed", e);
  }

  document.removeEventListener("pointerdown", unlockAudio);
};

document.addEventListener("pointerdown", unlockAudio);

  // document.addEventListener("click", unlockAudio);

  return () => {
    document.removeEventListener("click", unlockAudio);
  };
}, []);
  // Check authentication
  useEffect(() => {
    const checkAuth = () => {
      try {
        const userToken = localStorage.getItem('userToken');
        const userDataString = localStorage.getItem('userData');
        const userId = localStorage.getItem('userId') || localStorage.getItem('restaurantId');
        const userName = localStorage.getItem('userName') || localStorage.getItem('owner_name');
        
        if (userToken === 'authenticated' && userDataString && userId && userName) {
          const parsedUserData = JSON.parse(userDataString);
          if (parsedUserData.owner_name || parsedUserData.name) {
            setUserData(parsedUserData);
            setIsAuthenticated(true);
            setTimeout(() => loadOrders(), 500);
          } else {
            redirectToLogin();
          }
        } else {
          redirectToLogin();
        }
      } catch (error) {
        redirectToLogin();
      } finally {
        setLoading(false);
      }
    };

    const redirectToLogin = () => {
      ['userToken', 'userData', 'restaurantId', 'owner_name', 'userEmail', 'userId', 'userName'].forEach(key => localStorage.removeItem(key));
      navigate('/login', { replace: true });
    };

    checkAuth();
  }, [navigate]);

  // 🔥 Poll for new orders every 10 seconds
  useEffect(() => {
    if (isAuthenticated && userData) {
      loadOrders();
      const intervalId = setInterval(() => loadOrders(), 10000);
      return () => clearInterval(intervalId);
    }
  }, [isAuthenticated, userData?.id]);

  useEffect(() => {
    if (isAuthenticated && userData) loadOrders();
  }, [isRestaurantOpen]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ── RENDER ORDER POPUP ──
  const renderOrderPopup = () => {
    if (!orderPopup.visible || !orderPopup.orderData) return null;
    const order = orderPopup.orderData;
    const items = getSafeItems(order.items);

    const displayItems = items.map((item) => {
      let itemName = 'Item', quantity = '1';
      if (typeof item === 'object' && item !== null) {
        itemName = item.name || item.item_name || item.product_name || 'Item';
        quantity = item.qty || item.quantity || item.count || '1';
      } else if (typeof item === 'string') {
        const match = item.match(/^(\d+)x\s*(.+)$/);
        if (match) { quantity = match[1]; itemName = match[2]; }
        else { itemName = item; }
      }
      return { name: itemName, qty: quantity };
    });

    const popupStyles = {
      overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)', backdropFilter: 'blur(4px)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 99999, animation: 'fadeIn 0.3s ease',
      },
      container: {
        backgroundColor: isDark ? '#1e293b' : '#ffffff',
        borderRadius: '24px', padding: '28px', maxWidth: '460px', width: '92%',
        maxHeight: '90vh', overflowY: 'auto', position: 'relative',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)', border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : '#fed7aa'}`,
        animation: 'slideUp 0.4s ease',
      },
      close: {
        position: 'absolute', top: '16px', right: '16px', background: 'none',
        border: 'none', fontSize: '20px', cursor: 'pointer', color: isDark ? '#94a3b8' : '#999',
      },
      header: { textAlign: 'center', marginBottom: '20px' },
      title: { fontSize: '22px', fontWeight: '800', color: isDark ? '#f1f5f9' : '#0f172a', margin: '0 0 4px 0' },
      orderId: { fontSize: '13px', color: '#f97316', fontWeight: '700', fontFamily: 'monospace' },
      customer: {
        backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#fff7ed',
        borderRadius: '16px', padding: '16px', marginBottom: '16px', border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : '#fed7aa'}`,
      },
      customerName: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' },
      name: { fontSize: '16px', fontWeight: '700', color: isDark ? '#f1f5f9' : '#0f172a' },
      address: { display: 'flex', alignItems: 'flex-start', gap: '8px', fontSize: '13px', color: isDark ? '#94a3b8' : '#64748b', lineHeight: '1.4' },
      items: { backgroundColor: isDark ? 'rgba(255,255,255,0.03)' : '#f8fafc', borderRadius: '16px', padding: '16px', marginBottom: '16px' },
      itemsHeader: { display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: '700', color: isDark ? '#94a3b8' : '#64748b', marginBottom: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' },
      itemRow: { display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '14px', color: isDark ? '#f1f5f9' : '#0f172a', borderBottom: `1px dashed ${isDark ? 'rgba(255,255,255,0.05)' : '#e2e8f0'}` },
      earnings: { background: 'linear-gradient(135deg, #f97316, #fb923c)', borderRadius: '16px', padding: '16px', marginBottom: '20px', color: '#ffffff' },
      earningRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '14px' },
      earningAmount: { fontSize: '20px', fontWeight: '800', color: '#ffffff' },
      time: { fontWeight: '600', color: '#ffffff', opacity: 0.9 },
      actions: { display: 'flex', gap: '12px' },
      decline: {
        flex: 1, padding: '14px', borderRadius: '14px', border: `2px solid #dc2626`, backgroundColor: 'transparent',
        color: '#dc2626', fontWeight: '700', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s',
      },
      accept: {
        flex: 2, padding: '14px', borderRadius: '14px', border: 'none', background: 'linear-gradient(135deg, #10b981, #059669)', color: '#fff',
        fontWeight: '700', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)', transition: 'all 0.2s',
      },
    };

    return (
      <div style={popupStyles.overlay}>
        <div style={popupStyles.container}>
          <button style={popupStyles.close} onClick={() => {
    stopAlarm();
    popupOpenRef.current = false;
    // setTimerStarted(false);
    setOrderPopup({
        visible: false,
        orderData: null
    });
}}><FaTimes /></button>
          <div style={popupStyles.header}>
            <span style={{ fontSize: '36px', display: 'block', marginBottom: '8px' }}>🍽️</span>
            <h2 style={popupStyles.title}>New Order!</h2>
            <div
    style={{
        marginTop: 12,
        display: "flex",
        justifyContent: "center"
    }}
>
    <div
        style={{
            background: countdown <= 10 ? "#ef4444" : "#f97316",
            color: "#fff",
            padding: "8px 20px",
            borderRadius: 30,
            fontSize: 22,
            fontWeight: 700
        }}
    >
        ⏱ {countdown}s
    </div>
</div>
            <span style={popupStyles.orderId}>#{order.id}</span>
          </div>
          <div style={popupStyles.customer}>
            <div style={popupStyles.customerName}>
              <span style={{ fontSize: '20px' }}>👤</span>
              <span style={popupStyles.name}>{order.customer}</span>
            </div>
            <div style={popupStyles.address}>
              <FaMapMarkerAlt color="#f97316" style={{ marginTop: '3px' }} />
              <span>{order.address}</span>
            </div>
          </div>
          <div style={popupStyles.items}>
            <div style={popupStyles.itemsHeader}><span>Order Items</span><span>Qty</span></div>
            {displayItems.map((item, index) => (
              <div key={index} style={popupStyles.itemRow}>
                <span>{item.name}</span>
                <span style={{ fontWeight: '600' }}>{item.qty}</span>
              </div>
            ))}
          </div>
          <div style={popupStyles.earnings}>
            <div style={popupStyles.earningRow}><span>Restaurant Earning</span><span style={popupStyles.earningAmount}>₹{Number(order.restaurantEarning || 0).toFixed(2)}</span></div>
            <div style={popupStyles.earningRow}><span>Estimated Time</span><span style={popupStyles.time}>⏱️ {order.estimatedTime}</span></div>
          </div>
          <div style={popupStyles.actions}>
            <button style={popupStyles.decline} onClick={handleDeclineOrder} onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#dc2626'; e.currentTarget.style.color = '#fff'; }} onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#dc2626'; }}>
              <FaTimes size={16} style={{ marginRight: '6px' }} /> Decline
            </button>
            <button style={popupStyles.accept} onClick={handleAcceptOrder} onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.02)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}>
              <FaCheckDouble size={16} style={{ marginRight: '6px' }} /> Accept
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: isDark ? '#0f172a' : '#f8fafc', color: isDark ? '#fdba74' : '#ea580c', fontFamily: "'DM Sans', sans-serif", fontSize: '18px', fontWeight: 500, flexDirection: 'column', gap: '20px' }}>
        <div style={{ width: '40px', height: '40px', border: '3px solid rgba(249, 115, 22, 0.2)', borderTop: '3px solid #f97316', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        <span>Loading Dashboard...</span>
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  const isMobile = windowWidth <= 768;

  const getPageName = () => {
    const path = location.pathname;
    if (path === "/" || path === "/dashboard" || path === "/dashboard/home") return "Dashboard";
    const pageName = path.replace("/dashboard/", "").replace(/-/g, " ");
    return pageName.charAt(0).toUpperCase() + pageName.slice(1);
  };

  // 🎨 ORANGE THEME CONFIGURATION
  const t = isDark
    ? { bg: "#0f172a", pageBg: "#0f172a", text: "#f1f5f9", headerBg: "linear-gradient(135deg, #1e293b 0%, #334155 100%)", border: "rgba(249, 115, 22, 0.3)", titleColor: "#fb923c", shadow: "0 4px 20px rgba(0,0,0,0.5)", subtitleText: "#e2e8f0" }
    : { bg: "#f8fafc", pageBg: "#f8fafc", text: "#64748b", headerBg: "linear-gradient(135deg, #ffffff 0%, #fff7ed 100%)", border: "rgba(249, 115, 22, 0.2)", titleColor: "#ea580c", shadow: "0 4px 20px rgba(249, 115, 22, 0.1)", subtitleText: "#475569" };

  const styles = {
    appContainer: {
      display: "flex", height: "100vh", width: "100vw", overflow: "hidden",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif", backgroundColor: t.bg, position: "relative",
    },
    mainContent: {
      flex: 1, overflowY: "auto", backgroundColor: t.pageBg, position: "relative",
      paddingTop: isMobile ? "56px" : "0", filter: orderPopup.visible ? 'blur(6px)' : 'none',
      pointerEvents: orderPopup.visible ? 'none' : 'auto', transition: 'filter 0.3s ease',
    },
    header: {
      position: "sticky", top: 0, zIndex: 100, background: t.headerBg, padding: "12px 24px",
      borderBottom: `1px solid ${t.border}`, display: "flex", alignItems: "center", justifyContent: "space-between",
      backdropFilter: "blur(12px)", transition: "all 0.3s ease", boxShadow: t.shadow, flexWrap: "wrap", gap: "12px",
    },
    headerLeft: { display: "flex", flexDirection: "column", gap: "2px" },
    headerTitleWrapper: { display: "flex", alignItems: "center", gap: "10px" },
    accentDot: {
      width: "8px", height: "8px", borderRadius: "50%",
      background: "linear-gradient(135deg, #f97316 0%, #fb923c 100%)",
      boxShadow: isDark ? "0 0 10px rgba(249, 115, 22, 0.6)" : "0 0 10px rgba(249, 115, 22, 0.4)",
    },
    headerTitle: { fontSize: "20px", fontWeight: 800, color: t.titleColor, letterSpacing: "-0.5px", margin: 0 },
    headerSubtitle: { fontSize: "12px", color: isDark ? t.subtitleText : t.text, fontWeight: 500, marginLeft: "18px" },
    headerActions: { display: "flex", alignItems: "center", gap: "12px", flexWrap: "nowrap" },
    
    // 🔥 BEAUTIFUL & COMPACT HEADER BUTTONS
    newOrderButton: {
      display: "flex", alignItems: "center", gap: "8px",
      background: newOrdersCount > 0 ? "linear-gradient(135deg, #f97316, #ea580c)" : (isDark ? "#1e293b" : "#ffffff"),
      border: `1px solid ${newOrdersCount > 0 ? 'transparent' : (isDark ? 'rgba(255,255,255,0.1)' : '#e2e8f0')}`,
      borderRadius: "12px", padding: "0 16px", color: newOrdersCount > 0 ? "#ffffff" : (isDark ? "#f1f5f9" : "#475569"),
      fontSize: "13px", fontWeight: 600, cursor: "pointer", transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: newOrdersCount > 0 ? "0 4px 15px rgba(249, 115, 22, 0.3)" : "0 2px 8px rgba(0,0,0,0.05)",
      position: "relative", overflow: "hidden", height: "40px", minWidth: "140px", justifyContent: "center",
    },
    newOrderBadge: {
      position: "absolute", top: "-6px", right: "-6px", background: "#ef4444", color: "#ffffff",
      fontSize: "10px", fontWeight: 800, minWidth: "20px", height: "20px", borderRadius: "10px",
      display: "flex", alignItems: "center", justifyContent: "center",
      border: "2px solid " + (isDark ? "#1e293b" : "#ffffff"),
      boxShadow: "0 2px 6px rgba(239, 68, 68, 0.4)", padding: "0 4px",
      animation: newOrdersCount > 0 ? "pulseBadge 1.5s ease-in-out infinite" : "none",
    },
    toggleButton: {
      display: "flex", alignItems: "center", gap: "8px",
      background: isRestaurantOpen ? "linear-gradient(135deg, #10b981, #059669)" : "linear-gradient(135deg, #ef4444, #dc2626)",
      border: "none", borderRadius: "12px", padding: "0 16px", color: "#ffffff",
      fontSize: "13px", fontWeight: 700, cursor: isToggling ? "not-allowed" : "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: isRestaurantOpen ? "0 4px 15px rgba(16, 185, 129, 0.3)" : "0 4px 15px rgba(239, 68, 68, 0.3)",
      opacity: isToggling ? 0.7 : 1, position: "relative", overflow: "hidden", height: "40px", minWidth: "110px", justifyContent: "center",
    },
    statusDot: { width: "6px", height: "6px", borderRadius: "50%", background: "#ffffff", opacity: 0.9, display: "inline-block" },
    
    restaurantCard: {
      display: 'flex', alignItems: 'center', gap: '10px',
      background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(249, 115, 22, 0.08)',
      padding: '0 14px', borderRadius: '12px',
      border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(249, 115, 22, 0.2)'}`,
      height: "40px", transition: 'all 0.3s ease',
    },
    restaurantIcon: {
      width: '24px', height: '24px', borderRadius: '6px',
      background: isDark ? 'rgba(249, 115, 22, 0.2)' : 'rgba(249, 115, 22, 0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    },
    restaurantName: {
      fontSize: '13px', color: isDark ? '#f1f5f9' : '#0f172a', fontWeight: 700,
      whiteSpace: 'nowrap', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis',
    },
    restaurantLabel: {
      fontSize: '10px', color: isDark ? '#94a3b8' : '#64748b', fontWeight: 600,
      textTransform: 'uppercase', letterSpacing: '0.5px',
    },
    mobileMenuToggle: {
      position: "fixed", top: "12px", left: "12px", zIndex: 1000,
      background: isDark ? "#1e293b" : "#ffffff", border: `1px solid ${isDark ? "rgba(249, 115, 22, 0.3)" : "rgba(249, 115, 22, 0.2)"}`,
      borderRadius: "10px", padding: "10px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
      boxShadow: isDark ? "0 4px 12px rgba(0,0,0,0.4)" : "0 4px 12px rgba(249, 115, 22, 0.15)",
      transition: "all 0.2s ease", color: isDark ? "#fdba74" : "#ea580c",
    },
    headerContent: { paddingTop: isMobile ? "16px" : "24px", padding: isMobile ? "16px" : "24px 32px" }
  };

  return (
    <div style={styles.appContainer}>
      {renderOrderPopup()}

      {isMobile && (
        <div style={styles.mobileMenuToggle} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </div>
      )}

      <div style={{
        position: isMobile ? "fixed" : "relative", top: 0, left: 0, height: "100vh",
        transform: isMobile && !isMobileMenuOpen ? "translateX(-100%)" : "translateX(0)",
        transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)", zIndex: 999,
        boxShadow: isMobile && isMobileMenuOpen ? (isDark ? "0 0 30px rgba(0,0,0,0.6)" : "0 0 30px rgba(249, 115, 22, 0.2)") : "none",
        filter: 'none', pointerEvents: 'auto',
      }}>
        <Sidebar activeItem={activeItem} setActiveItem={setActiveItem} isSidebarCollapsed={isSidebarCollapsed}
          setIsSidebarCollapsed={setIsSidebarCollapsed} isDark={isDark} setIsDark={setIsDark}
          onMobileClose={() => setIsMobileMenuOpen(false)} />
      </div>

      {isMobile && isMobileMenuOpen && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(15, 23, 42, 0.6)", backdropFilter: "blur(4px)", zIndex: 998, animation: "fadeIn 0.2s ease" }} onClick={() => setIsMobileMenuOpen(false)} />
      )}

      <main style={styles.mainContent}>
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.headerTitleWrapper}>
              <div style={styles.accentDot} />
              <h1 style={styles.headerTitle}>{getPageName()}</h1>
            </div>
            <div style={styles.headerSubtitle}>
              {userData && `Welcome, ${userData.owner_name || userData.name || 'Vendor'}!`}
            </div>
          </div>
          
          <div style={styles.headerActions}>
            {/* 🔥 Compact & Beautiful New Order Button */}
            <button
              onClick={handleNewOrderClick}
              disabled={isLoadingOrders}
              style={styles.newOrderButton}
              onMouseEnter={(e) => { if (!isLoadingOrders) e.currentTarget.style.transform = 'translateY(-2px) scale(1.02)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; }}
              title={newOrdersCount > 0 ? `Click to view ${newOrdersCount} pending order${newOrdersCount > 1 ? 's' : ''}` : 'Click to view Live Orders Terminal'}
            >
              {newOrdersCount > 0 && <div style={styles.newOrderBadge}>{newOrdersCount}</div>}
              {isLoadingOrders ? (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <FaSpinner style={{ animation: 'spin 0.8s linear infinite' }} />
                  <span>Checking...</span>
                </div>
              ) : (
                <>
                  <FaBell size={16} />
                  <span>{newOrdersCount > 0 ? `New Order${newOrdersCount > 1 ? 's' : ''}` : 'Live Terminal'}</span>
                  <FaArrowRight size={12} />
                </>
              )}
            </button>

            {/* 🔥 Compact & Beautiful Toggle Button */}
            <button
              onClick={toggleRestaurantStatus}
              disabled={isToggling}
              style={styles.toggleButton}
              onMouseEnter={(e) => { if (!isToggling) e.currentTarget.style.transform = 'translateY(-2px) scale(1.02)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; }}
            >
              {isToggling ? (
                <FaSpinner style={{ animation: 'spin 0.8s linear infinite' }} />
              ) : (
                isRestaurantOpen ? <FaToggleOn style={{ width: '20px', height: '20px' }} /> : <FaToggleOff style={{ width: '20px', height: '20px' }} />
              )}
              <span>{isToggling ? "Updating..." : isRestaurantOpen ? "OPEN" : "CLOSED"}</span>
              <span style={styles.statusDot} />
            </button>

            {/* 🔥 Compact & Beautiful Restaurant Card */}
            <div style={styles.restaurantCard}>
              <div style={styles.restaurantIcon}>
                <FaStore size={14} color={isDark ? '#fb923c' : '#f97316'} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={styles.restaurantLabel}>Restaurant</span>
                <span style={styles.restaurantName}>
                  {userData?.organisation_name || userData?.restaurant_name || 'My Restaurant'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style={styles.headerContent}>
          <Routes>
            <Route path="/" element={<DashboardHome isDark={isDark} />} />
            <Route path="/Campaigns" element={<Campaigns isDark={isDark} />} />
            <Route path="/OrdersList" element={<OrdersList isDark={isDark} />} />
            <Route path="/EarningsDashboard" element={<EarningsDashboard isDark={isDark} />} />
            <Route path="/MenuMaster" element={<MenuMaster isDark={isDark} />} />
            <Route path="/StoreProfile" element={<StoreProfile isDark={isDark} />} />
            <Route path="/MOUAgreement" element={<MOUAgreement isDark={isDark} />} />
            <Route path="/INITIAL_NOTIFICATIONS" element={<INITIAL_NOTIFICATIONS isDark={isDark} />} />
            <Route path="/AddOffer" element={<AddOffer isDark={isDark} />} />
            <Route path="/SupportTicket" element={<SupportTicket isDark={isDark} />} />
            <Route path="/HelpSupport" element={<HelpSupport isDark={isDark} />} />
            <Route path="/VerificationScreen" element={<VerificationScreen isDark={isDark} />} />
            <Route path="/MenuUpdate" element={<MenuUpdate isDark={isDark} />} />
            <Route path="/EditAddress" element={<EditAddressScreen isDark={isDark} />} />
            <Route path="/RestaurantProfile" element={<RestaurantProfile isDark={isDark} />} />
            <Route path="/LiveOrdersTerminal" element={<LiveOrdersTerminal isDark={isDark} />} />
          </Routes>
        </div>
      </main>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes pulseBadge {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.15); }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;